import { httpsCallable, type HttpsCallable } from 'firebase/functions';
import { z } from 'zod';

import { functions } from '../firebase.js';
import { SchemaValidationFailedError } from '@kilat/shared';

/**
 * Typed wrappers around marketing Cloud Functions.
 */

// ── runCampaignNow (Sprint 36) ────────────────────────────────────────

export const RunCampaignNowInputSchema = z.object({
  tenantId: z.string().min(1),
  campaignId: z.string().min(1),
});
export type RunCampaignNowInput = z.infer<typeof RunCampaignNowInputSchema>;

export const RunCampaignNowOutputSchema = z.object({
  sent: z.number().int().nonnegative(),
  skippedNoPrefs: z.number().int().nonnegative(),
  skippedQuietHours: z.number().int().nonnegative(),
  skippedNoTokens: z.number().int().nonnegative(),
  failed: z.number().int().nonnegative(),
  audienceSize: z.number().int().nonnegative(),
});
export type RunCampaignNowOutput = z.infer<typeof RunCampaignNowOutputSchema>;

const runCampaignNowFn: HttpsCallable<RunCampaignNowInput, RunCampaignNowOutput> = httpsCallable(
  functions,
  'runCampaignNow',
);

export async function callRunCampaignNow(
  input: RunCampaignNowInput,
): Promise<RunCampaignNowOutput> {
  const parsed = RunCampaignNowInputSchema.safeParse(input);
  if (!parsed.success) {
    throw new SchemaValidationFailedError('runCampaignNow.input', parsed.error.flatten());
  }
  const result = await runCampaignNowFn(parsed.data);
  const out = RunCampaignNowOutputSchema.safeParse(result.data);
  if (!out.success) {
    throw new SchemaValidationFailedError('runCampaignNow.output', out.error.flatten());
  }
  return out.data;
}
